import type { BrowserInfo } from '@mangopay/checkout-sdk-core';

export const getBrowserInfo = (): BrowserInfo => {
  const screenWidth = window && window.screen && window.screen.width;
  const screenHeight = window && window.screen && window.screen.height;
  const colorDepth = window && window.screen && window.screen.colorDepth;
  const userAgent = window && window.navigator ? window.navigator.userAgent : '';
  const language = window && window.navigator ? window.navigator.language : '';

  return {
    AcceptHeader: '*/*',
    JavaEnabled: false,
    Language: language,
    ColorDepth: colorDepth,
    ScreenHeight: screenHeight,
    ScreenWidth: screenWidth,
    TimeZoneOffset: new Date().getTimezoneOffset(),
    UserAgent: userAgent,
    JavascriptEnabled: true,
  };
};
